const emitChoiceSelected = ({ nextProduct }) => {
  let win;
  if (typeof window !== 'undefined') {
    win = window;
  } else if (typeof global !== 'undefined' && global.window) {
    win = global.window;
  }

  const bus = win?.LIFE_CYCLE_EVENT_BUS?.lifeCycle;
  if (!bus) return;

  bus.trigger('product.choice-selected', {
    output: {
      choice: nextProduct,
      timestamp: Date.now(),
      source: 'configurator-store',
    },
  });
};

const setSelectedProduct = (set, get, product) => {
  if (!product?.id) return;

  set({ selectedProduct: product });

  emitChoiceSelected({
    nextProduct: product,
  });
};

const clearSelectedProduct = (set) => {
  set({ selectedProduct: null });
};

const getSelectedProduct = (get) => {
  return get().selectedProduct;
};

export {
  setSelectedProduct,
  clearSelectedProduct,
  getSelectedProduct,
};
